import React, { useState } from "react";
import { PersistGate } from "redux-persist/integration/react";


type Props = {
  children: any;
  persistor: any;
};

function PermissionAndPersist({ children, persistor }: Props) {
  return <PersistGate persistor={persistor}>{children}</PersistGate>;
}

export default PermissionAndPersist;
